import { useCssHandles } from '../../../../utils/functions';

const StyledLinkContent = ({ type, itemProps, blockClass, isOpen, isCollapsible }) => {
	const { handles, withModifiers } = useCssHandles('vtex-menu-2-x', ['styledLinkContent', 'accordionIcon'], blockClass);
	const accordionClasses = withModifiers('accordionIcon', isOpen ? 'isOpen' : 'isClosed');
	const renderComponent = () => {
		switch (type) {
			case 'category':
				return (
					<div className={`${handles.styledLinkContent} flex justify-between nowrap`}>
						{itemProps?.text}
						{isCollapsible && <AccordionIcon classes={accordionClasses} isOpen={isOpen} />}
					</div>
				);
			case 'custom':
				return (
					<div className={`${handles.styledLinkContent}  flex justify-between nowrap`}>
						{itemProps?.text}
						{isCollapsible && <AccordionIcon classes={accordionClasses} isOpen={isOpen} />}
					</div>
				);
			default:
				return <></>;
		}
	};

	return renderComponent();
};

const AccordionIcon = ({ classes, isOpen }) => {
	return <div className={`${classes} ml3 c-muted-2`}>{isOpen ? '-' : '+'} </div>;
};

export default StyledLinkContent;
